module.exports = __webpack_public_path__ + "img/create.b0e67656.png";